
import { TemplateCategory } from "./types";

export const criminaisCategory: TemplateCategory = {
  id: 'criminais',
  name: 'Criminais',
  emoji: '🚔',
  description: 'Documentos de direito criminal',
  subcategories: [
    {
      id: 'denuncias-criminais',
      name: 'Denúncias e Queixas',
      emoji: '📋',
      templates: [
        {
          id: 'denuncia-criminal',
          name: 'Denúncia criminal',
          type: 'Denúncia',
          description: 'Denúncia pelo Ministério Público',
          icon: 'Scale',
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA [VARA] VARA CRIMINAL

O MINISTÉRIO PÚBLICO DO ESTADO DE [ESTADO], no uso de suas atribuições legais, vem perante Vossa Excelência oferecer

DENÚNCIA

contra [NOME DO DENUNCIADO], [QUALIFICAÇÃO], pelos fatos e fundamentos jurídicos seguintes:

I - DOS FATOS
[NARRATIVA DOS FATOS]

II - DA TIPIFICAÇÃO
[ENQUADRAMENTO LEGAL]

III - DOS PEDIDOS
Ante o exposto, o Ministério Público requer:
a) O recebimento da denúncia
b) A citação do denunciado
c) A instrução do feito
d) A condenação pelos crimes descritos

[LOCAL], [DATA]

_________________________________
[NOME DO PROMOTOR]
PROMOTOR DE JUSTIÇA`
        },
        {
          id: 'queixa-crime',
          name: 'Queixa-crime',
          type: 'Queixa',
          description: 'Queixa por crime de ação privada',
          icon: 'FileText',
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO QUERELANTE], [QUALIFICAÇÃO], vem perante Vossa Excelência, por seu advogado que esta subscreve, oferecer

QUEIXA-CRIME

contra [NOME DO QUERELADO], [QUALIFICAÇÃO]:

DOS FATOS:
[NARRATIVA DETALHADA]

DO CRIME:
O fato constitui crime de [TIPIFICAÇÃO], previsto no art. [ARTIGO] do Código Penal.

DOS PEDIDOS:
a) Recebimento da queixa
b) Citação do querelado
c) Instrução e julgamento
d) Condenação

Dá-se à causa o valor de R$ [VALOR].

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'representacao-criminal',
          name: 'Representação criminal',
          type: 'Representação',
          description: 'Representação para crimes condicionados',
          icon: 'AlertTriangle',
          content: `REPRESENTAÇÃO CRIMINAL

À AUTORIDADE POLICIAL

[NOME DO REPRESENTANTE], [QUALIFICAÇÃO], vem representar contra [NOME DO REPRESENTADO] pelos fatos a seguir narrados:

DOS FATOS:
[DESCRIÇÃO DETALHADA]

DA AUTORIA:
[INDICAÇÃO DA AUTORIA]

CRIME PRATICADO:
[TIPIFICAÇÃO]

PEDIDOS:
a) Instauração de inquérito policial
b) Investigação dos fatos
c) Indiciamento do autor

[LOCAL], [DATA]

_________________________________
[NOME DO REPRESENTANTE]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'denuncia-homicidio',
          name: 'Denúncia por homicídio',
          type: 'Denúncia',
          description: 'Denúncia específica para crime de homicídio',
          icon: 'AlertTriangle',
          content: `DENÚNCIA POR HOMICÍDIO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

O MINISTÉRIO PÚBLICO oferece DENÚNCIA contra [NOME], pelos fatos a seguir:

DOS FATOS:
No dia [DATA], por volta das [HORA], [DESCRIÇÃO DOS FATOS].

A vítima [NOME DA VÍTIMA] veio a óbito em decorrência de [CAUSA DA MORTE].

DA TIPIFICAÇÃO:
Art. 121 do Código Penal (Homicídio)
( ) Simples
( ) Qualificado por: [QUALIFICADORA]

DOS PEDIDOS:
a) Recebimento da denúncia
b) Citação do réu
c) Condenação

[LOCAL], [DATA]

_________________________________
[NOME DO PROMOTOR]
PROMOTOR DE JUSTIÇA`
        },
        {
          id: 'denuncia-trafico',
          name: 'Denúncia por tráfico de drogas',
          type: 'Denúncia',
          description: 'Denúncia por crime de tráfico',
          icon: 'Shield',
          content: `DENÚNCIA POR TRÁFICO DE DROGAS

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

O MINISTÉRIO PÚBLICO oferece DENÚNCIA contra [NOME]:

DOS FATOS:
Em [DATA], o denunciado foi flagrado [DESCRIÇÃO DA CONDUTA].

Apreendida substância entorpecente: [TIPO E QUANTIDADE].

DA TIPIFICAÇÃO:
Art. 33 da Lei 11.343/06 (Tráfico de Drogas)

AGRAVANTES:
[SE HOUVER]

DOS PEDIDOS:
a) Recebimento da denúncia
b) Condenação

[LOCAL], [DATA]

_________________________________
[NOME DO PROMOTOR]
PROMOTOR DE JUSTIÇA`
        },
        {
          id: 'queixa-injuria',
          name: 'Queixa por injúria',
          type: 'Queixa',
          description: 'Queixa-crime por injúria',
          icon: 'MessageSquare',
          content: `QUEIXA-CRIME POR INJÚRIA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO QUERELANTE] oferece QUEIXA-CRIME contra [NOME]:

DOS FATOS:
Em [DATA], o querelado proferiu as seguintes palavras ofensivas: "[PALAVRAS]".

DA TIPIFICAÇÃO:
Art. 140 do Código Penal (Injúria)

DOS PEDIDOS:
a) Recebimento da queixa
b) Condenação
c) Indenização por danos morais

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'queixa-difamacao',
          name: 'Queixa por difamação',
          type: 'Queixa',
          description: 'Queixa-crime por difamação',
          icon: 'Users',
          content: `QUEIXA-CRIME POR DIFAMAÇÃO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO QUERELANTE] oferece QUEIXA-CRIME:

DOS FATOS:
O querelado [NOME] imputou ao querelante fato ofensivo à sua reputação: [DESCRIÇÃO].

DIVULGAÇÃO:
A difamação foi praticada [FORMA DE DIVULGAÇÃO].

DA TIPIFICAÇÃO:
Art. 139 do Código Penal (Difamação)

DOS PEDIDOS:
a) Recebimento da queixa
b) Condenação

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'queixa-caluna',
          name: 'Queixa por calúnia',
          type: 'Queixa',
          description: 'Queixa-crime por calúnia',
          icon: 'AlertCircle',
          content: `QUEIXA-CRIME POR CALÚNIA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO QUERELANTE] oferece QUEIXA-CRIME:

DOS FATOS:
O querelado imputou falsamente ao querelante a prática do crime de [CRIME IMPUTADO].

FALSIDADE:
A imputação é falsa porque [DEMONSTRAÇÃO DA FALSIDADE].

DA TIPIFICAÇÃO:
Art. 138 do Código Penal (Calúnia)

DOS PEDIDOS:
a) Recebimento da queixa
b) Condenação

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        }
      ]
    },
    {
      id: 'defesas-criminais',
      name: 'Defesas Criminais',
      emoji: '🛡️',
      templates: [
        {
          id: 'resposta-acusacao',
          name: 'Resposta à acusação',
          type: 'Defesa',
          description: 'Resposta preliminar do réu',
          icon: 'Shield',
          content: `RESPOSTA À ACUSAÇÃO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO RÉU], por seu defensor que esta subscreve, vem apresentar RESPOSTA À ACUSAÇÃO nos autos do processo crime nº [NÚMERO]:

I - PRELIMINARES
[QUESTÕES PRELIMINARES]

II - DO MÉRITO
[DEFESA DE MÉRITO]

III - DAS PROVAS
Requer a produção das seguintes provas:
a) Testemunhal: [RELAÇÃO]
b) Documental: [ESPECIFICAR]
c) Pericial: [SE NECESSÁRIA]

IV - DOS PEDIDOS
a) Rejeição da denúncia/queixa
b) Absolvição
c) Desclassificação

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'alegacoes-finais',
          name: 'Alegações finais',
          type: 'Alegações',
          description: 'Alegações finais da defesa',
          icon: 'FileText',
          content: `ALEGAÇÕES FINAIS

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa de [NOME DO RÉU] vem apresentar suas alegações finais:

I - DOS FATOS APURADOS
[RESUMO DA INSTRUÇÃO]

II - DA ANÁLISE DAS PROVAS
[ANÁLISE CRÍTICA]

III - DO DIREITO
[FUNDAMENTAÇÃO JURÍDICA]

IV - DOS PEDIDOS
Requer:
a) Absolvição por [FUNDAMENTO]
b) Subsidiariamente, desclassificação
c) Reconhecimento de atenuantes

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-preliminar',
          name: 'Defesa preliminar',
          type: 'Defesa',
          description: 'Defesa preliminar antes do recebimento',
          icon: 'FileCheck',
          content: `DEFESA PRELIMINAR

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa de [NOME DO ACUSADO] apresenta defesa preliminar:

I - DA INÉPCIA DA INICIAL ACUSATÓRIA
[FUNDAMENTAÇÃO]

II - DA FALTA DE JUSTA CAUSA
[ARGUMENTAÇÃO]

III - DA ATIPICIDADE DA CONDUTA
[DEMONSTRAÇÃO]

IV - DOS PEDIDOS
a) Rejeição da denúncia/queixa
b) Trancamento da ação penal

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-legitima-defesa',
          name: 'Defesa por legítima defesa',
          type: 'Defesa',
          description: 'Tese de legítima defesa',
          icon: 'Shield',
          content: `ALEGAÇÃO DE LEGÍTIMA DEFESA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa sustenta a LEGÍTIMA DEFESA:

I - DOS REQUISITOS
a) Agressão injusta: [DEMONSTRAÇÃO]
b) Atualidade da agressão: [PROVA]
c) Uso moderado dos meios necessários: [ANÁLISE]
d) Conhecimento da situação de agressão: [EVIDÊNCIA]

II - DA PROVA
[ELEMENTOS PROBATÓRIOS]

III - DOS PEDIDOS
Absolvição por legítima defesa (art. 25, CP)

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-estado-necessidade',
          name: 'Defesa por estado de necessidade',
          type: 'Defesa',
          description: 'Tese de estado de necessidade',
          icon: 'AlertTriangle',
          content: `ALEGAÇÃO DE ESTADO DE NECESSIDADE

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa alega ESTADO DE NECESSIDADE:

I - DOS REQUISITOS
a) Perigo atual: [SITUAÇÃO]
b) Ameaça a direito próprio ou alheio: [DEMONSTRAÇÃO]
c) Inevitabilidade do perigo: [PROVA]
d) Inexigibilidade de sacrifício do interesse ameaçado: [ANÁLISE]

II - DA SITUAÇÃO FÁTICA
[DESCRIÇÃO DETALHADA]

III - DOS PEDIDOS
Absolvição por estado de necessidade (art. 24, CP)

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-inimputabilidade',
          name: 'Defesa por inimputabilidade',
          type: 'Defesa',
          description: 'Alegação de inimputabilidade',
          icon: 'Brain',
          content: `ALEGAÇÃO DE INIMPUTABILIDADE

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa alega INIMPUTABILIDADE:

I - DA DOENÇA MENTAL
Tipo: [PATOLOGIA]
Diagnóstico: [LAUDO MÉDICO]

II - DO NEXO CAUSAL
A doença mental retirou completamente a capacidade de entendimento e autodeterminação.

III - DAS PROVAS
a) Laudo psiquiátrico
b) Histórico médico
c) Testemunhas

IV - DOS PEDIDOS
a) Absolvição imprópria
b) Aplicação de medida de segurança

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-coacao-irresistivel',
          name: 'Defesa por coação irresistível',
          type: 'Defesa',
          description: 'Tese de coação irresistível',
          icon: 'HandStop',
          content: `ALEGAÇÃO DE COAÇÃO IRRESISTÍVEL

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa alega COAÇÃO IRRESISTÍVEL:

I - DA COAÇÃO SOFRIDA
Tipo: [FÍSICA/MORAL]
Autor da coação: [IDENTIFICAÇÃO]
Forma: [DESCRIÇÃO]

II - DOS REQUISITOS
a) Irresistibilidade: [DEMONSTRAÇÃO]
b) Gravidade da ameaça: [ANÁLISE]
c) Atualidade do perigo: [PROVA]

III - DOS PEDIDOS
Absolvição por coação irresistível (art. 22, CP)

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-obediencia-hierarquica',
          name: 'Defesa por obediência hierárquica',
          type: 'Defesa',
          description: 'Tese de obediência hierárquica',
          icon: 'Users',
          content: `ALEGAÇÃO DE OBEDIÊNCIA HIERÁRQUICA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa alega OBEDIÊNCIA HIERÁRQUICA:

I - DA RELAÇÃO HIERÁRQUICA
Superior hierárquico: [IDENTIFICAÇÃO]
Subordinado: [ACUSADO]
Natureza da relação: [TIPO]

II - DA ORDEM RECEBIDA
Conteúdo: [DESCRIÇÃO DA ORDEM]
Forma: [COMO FOI DADA]

III - DOS REQUISITOS
a) Ordem de superior hierárquico
b) Ordem não manifestamente ilegal
c) Competência do superior

IV - DOS PEDIDOS
Absolvição por obediência hierárquica (art. 22, CP)

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        }
      ]
    },
    {
      id: 'recursos-criminais',
      name: 'Recursos Criminais',
      emoji: '📑',
      templates: [
        {
          id: 'apelacao-criminal',
          name: 'Apelação criminal',
          type: 'Recurso',
          description: 'Recurso de apelação em processo crime',
          icon: 'Scale',
          content: `APELAÇÃO CRIMINAL

EGRÉGIO TRIBUNAL DE JUSTIÇA DO ESTADO DE [ESTADO]

[NOME DO APELANTE], por seu defensor, vem interpor APELAÇÃO contra a r. sentença de fls. [FOLHAS]:

I - DO JUÍZO DE ADMISSIBILIDADE
[TEMPESTIVIDADE E LEGITIMIDADE]

II - DO MÉRITO
[FUNDAMENTOS DO RECURSO]

III - DOS PEDIDOS
a) Provimento para absolver
b) Subsidiariamente, redução da pena
c) Reconhecimento de atenuantes

Nestes termos, pede provimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'habeas-corpus',
          name: 'Habeas corpus',
          type: 'Habeas Corpus',
          description: 'Remédio constitucional para liberdade',
          icon: 'Unlock',
          content: `HABEAS CORPUS

EGRÉGIO TRIBUNAL DE JUSTIÇA

IMPETRANTE: [NOME DO ADVOGADO]
PACIENTE: [NOME]
COATOR: [AUTORIDADE]

O advogado abaixo assinado vem impetrar HABEAS CORPUS em favor do paciente:

I - DOS FATOS
[NARRATIVA DOS FATOS]

II - DO CONSTRANGIMENTO ILEGAL
[FUNDAMENTAÇÃO]

III - DO DIREITO
[BASE LEGAL]

IV - DOS PEDIDOS
a) Concessão da ordem
b) Relaxamento da prisão
c) Liberdade provisória

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'recurso-sentido-estrito',
          name: 'Recurso em sentido estrito',
          type: 'Recurso',
          description: 'Recurso contra decisões interlocutórias',
          icon: 'FileText',
          content: `RECURSO EM SENTIDO ESTRITO

EGRÉGIO TRIBUNAL DE JUSTIÇA

[NOME DO RECORRENTE] interpõe RECURSO EM SENTIDO ESTRITO contra decisão que [OBJETO]:

I - DA DECISÃO RECORRIDA
[RESUMO DA DECISÃO]

II - DOS FUNDAMENTOS
[ARGUMENTAÇÃO JURÍDICA]

III - DOS PEDIDOS
a) Provimento do recurso
b) Reforma da decisão

Nestes termos, pede provimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'agravo-execucao',
          name: 'Agravo em execução',
          type: 'Recurso',
          description: 'Recurso na fase de execução penal',
          icon: 'Gavel',
          content: `AGRAVO EM EXECUÇÃO

EGRÉGIO TRIBUNAL DE JUSTIÇA

[NOME DO AGRAVANTE] interpõe AGRAVO contra decisão em execução:

I - DA DECISÃO AGRAVADA
[TEOR DA DECISÃO]

II - DOS FUNDAMENTOS
[ARGUMENTAÇÃO]

III - DOS PEDIDOS
a) Provimento do agravo
b) Reforma da decisão

Nestes termos, pede provimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'embargos-declaracao-criminal',
          name: 'Embargos de declaração criminal',
          type: 'Embargos',
          description: 'Esclarecimento de decisão criminal',
          icon: 'MessageCircle',
          content: `EMBARGOS DE DECLARAÇÃO

EGRÉGIO TRIBUNAL DE JUSTIÇA

[NOME DO EMBARGANTE] opõe EMBARGOS DE DECLARAÇÃO:

I - DA OBSCURIDADE/CONTRADIÇÃO/OMISSÃO
[APONTAMENTO DO VÍCIO]

II - DOS PEDIDOS
a) Acolhimento dos embargos
b) Esclarecimento da decisão

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'recurso-especial-criminal',
          name: 'Recurso especial criminal',
          type: 'Recurso',
          description: 'Recurso ao STJ em matéria criminal',
          icon: 'Crown',
          content: `RECURSO ESPECIAL

SUPERIOR TRIBUNAL DE JUSTIÇA

[NOME DO RECORRENTE] interpõe RECURSO ESPECIAL:

I - DO CABIMENTO
a) Violação da lei federal: [ESPECIFICAR]
b) Divergência jurisprudencial: [DEMONSTRAR]

II - DO PREQUESTIONAMENTO
[DEMONSTRAÇÃO]

III - DOS FUNDAMENTOS
[ARGUMENTAÇÃO]

IV - DOS PEDIDOS
Conhecimento e provimento

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        }
      ]
    },
    {
      id: 'medidas-cautelares',
      name: 'Medidas Cautelares',
      emoji: '⚠️',
      templates: [
        {
          id: 'liberdade-provisoria',
          name: 'Pedido de liberdade provisória',
          type: 'Cautelar',
          description: 'Pedido de liberdade provisória',
          icon: 'Unlock',
          content: `PEDIDO DE LIBERDADE PROVISÓRIA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO REQUERENTE], por seu defensor, vem requerer LIBERDADE PROVISÓRIA:

I - DA SITUAÇÃO
[DESCRIÇÃO DA PRISÃO]

II - DOS REQUISITOS LEGAIS
[FUNDAMENTAÇÃO]

III - DAS MEDIDAS CAUTELARES
Oferece-se o cumprimento das seguintes medidas:
a) Comparecimento mensal em juízo
b) Proibição de ausentar-se da comarca
c) Outras: [ESPECIFICAR]

IV - DOS PEDIDOS
a) Concessão da liberdade provisória
b) Fixação de medidas cautelares

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'revogacao-prisao',
          name: 'Pedido de revogação de prisão preventiva',
          type: 'Cautelar',
          description: 'Revogação de prisão preventiva',
          icon: 'Unlock',
          content: `PEDIDO DE REVOGAÇÃO DE PRISÃO PREVENTIVA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa de [NOME] vem requerer a revogação da prisão preventiva:

I - DA PRISÃO DECRETADA
[FUNDAMENTAÇÃO DA DECISÃO]

II - DA SUPERVENIÊNCIA
[FATOS NOVOS]

III - DO DIREITO
[FUNDAMENTAÇÃO JURÍDICA]

IV - DOS PEDIDOS
a) Revogação da prisão preventiva
b) Concessão de liberdade provisória
c) Fixação de medidas cautelares

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'relaxamento-prisao',
          name: 'Pedido de relaxamento de prisão',
          type: 'Cautelar',
          description: 'Relaxamento de prisão ilegal',
          icon: 'Unlock',
          content: `PEDIDO DE RELAXAMENTO DE PRISÃO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa de [NOME] requer o RELAXAMENTO DA PRISÃO:

I - DA PRISÃO EM FLAGRANTE
Data: [DATA]
Motivo: [RAZÃO]

II - DA ILEGALIDADE
[VÍCIOS DA PRISÃO]

III - DOS FUNDAMENTOS LEGAIS
Art. 5º, LXV, CF/88
Art. 310, I, CPP

IV - DOS PEDIDOS
a) Relaxamento da prisão
b) Expedição de alvará de soltura

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'substituicao-prisao',
          name: 'Pedido de substituição de prisão',
          type: 'Cautelar',
          description: 'Substituição por medidas cautelares',
          icon: 'RefreshCw',
          content: `PEDIDO DE SUBSTITUIÇÃO DE PRISÃO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa requer a SUBSTITUIÇÃO da prisão por medidas cautelares:

I - DA DESNECESSIDADE DA PRISÃO
[FUNDAMENTAÇÃO]

II - DAS MEDIDAS PROPOSTAS
a) Monitoração eletrônica
b) Comparecimento periódico
c) Recolhimento domiciliar
d) Outras: [ESPECIFICAR]

III - DOS PEDIDOS
Substituição da prisão pelas medidas cautelares

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'prisao-domiciliar',
          name: 'Pedido de prisão domiciliar',
          type: 'Cautelar',
          description: 'Conversão em prisão domiciliar',
          icon: 'Home',
          content: `PEDIDO DE PRISÃO DOMICILIAR

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa requer a conversão em PRISÃO DOMICILIAR:

I - DOS REQUISITOS LEGAIS
( ) Maior de 80 anos
( ) Extremamente debilitado
( ) Imprescindível aos cuidados especiais de pessoa menor de 6 anos
( ) Gestante
( ) Mulher com filho de até 12 anos

II - DA COMPROVAÇÃO
[DOCUMENTOS]

III - DOS PEDIDOS
Conversão da prisão em domiciliar

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'medida-protetiva',
          name: 'Pedido de medida protetiva',
          type: 'Cautelar',
          description: 'Medida protetiva de urgência',
          icon: 'Shield',
          content: `PEDIDO DE MEDIDA PROTETIVA DE URGÊNCIA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DA REQUERENTE] requer MEDIDA PROTETIVA:

I - DOS FATOS
[VIOLÊNCIA SOFRIDA]

II - DO RISCO
[DEMONSTRAÇÃO DO PERIGO]

III - DAS MEDIDAS REQUERIDAS
a) Afastamento do agressor do lar
b) Proibição de aproximação
c) Proibição de contato
d) Outras: [ESPECIFICAR]

IV - DA URGÊNCIA
[JUSTIFICATIVA]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        }
      ]
    },
    {
      id: 'execucao-criminal',
      name: 'Execução Criminal',
      emoji: '⚖️',
      templates: [
        {
          id: 'progressao-regime',
          name: 'Pedido de progressão de regime',
          type: 'Execução',
          description: 'Progressão para regime menos rigoroso',
          icon: 'TrendingUp',
          content: `PEDIDO DE PROGRESSÃO DE REGIME

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DA EXECUÇÃO CRIMINAL

[NOME DO REEDUCANDO] vem requerer progressão de regime:

I - DA SITUAÇÃO ATUAL
Regime: [ATUAL]
Regime pretendido: [PRETENDIDO]

II - DOS REQUISITOS
a) Objetivo: [TEMPO CUMPRIDO]
b) Subjetivo: [BOM COMPORTAMENTO]

III - DA DOCUMENTAÇÃO
[RELAÇÃO DOS DOCUMENTOS]

IV - DOS PEDIDOS
a) Progressão para regime [TIPO]
b) Expedição de guia
c) Fixação de condições

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'livramento-condicional',
          name: 'Pedido de livramento condicional',
          type: 'Execução',
          description: 'Concessão de livramento condicional',
          icon: 'Key',
          content: `PEDIDO DE LIVRAMENTO CONDICIONAL

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DA EXECUÇÃO

[NOME DO REEDUCANDO] vem requerer livramento condicional:

I - DA CONDENAÇÃO
Pena: [ESPECIFICAÇÃO]
Início do cumprimento: [DATA]

II - DOS REQUISITOS
a) Cumprimento de [FRAÇÃO] da pena
b) Bom comportamento carcerário
c) Reparação do dano (se possível)

III - DAS CONDIÇÕES
[PROPOSTA DE CONDIÇÕES]

IV - DOS PEDIDOS
a) Concessão do livramento condicional
b) Fixação das condições
c) Expedição de alvará

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'remicao-pena',
          name: 'Pedido de remição de pena',
          type: 'Execução',
          description: 'Remição por trabalho ou estudo',
          icon: 'BookOpen',
          content: `PEDIDO DE REMIÇÃO DE PENA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DA EXECUÇÃO

[NOME DO REEDUCANDO] vem requerer remição de pena:

I - DO TRABALHO/ESTUDO
Atividade: [DESCRIÇÃO]
Período: [INÍCIO] a [FIM]
Horas trabalhadas/estudadas: [TOTAL]

II - DO CÁLCULO
[CÁLCULO DA REMIÇÃO]

III - DA DOCUMENTAÇÃO
[RELAÇÃO DOS DOCUMENTOS]

IV - DOS PEDIDOS
a) Declaração da remição
b) Abatimento da pena
c) Retificação da guia

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'indulto-comutacao',
          name: 'Pedido de indulto ou comutação',
          type: 'Execução',
          description: 'Pedido de graça presidencial',
          icon: 'Award',
          content: `PEDIDO DE INDULTO/COMUTAÇÃO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DA EXECUÇÃO

[NOME DO REEDUCANDO] requer INDULTO/COMUTAÇÃO:

I - DOS REQUISITOS DO DECRETO
Decreto nº [NÚMERO]/[ANO]
Requisitos: [ESPECIFICAÇÃO]

II - DO PREENCHIMENTO
a) Idade: [IDADE]
b) Pena: [DESCRIÇÃO]
c) Tempo cumprido: [PERÍODO]
d) Comportamento: [ATESTADO]

III - DOS PEDIDOS
( ) Indulto
( ) Comutação da pena

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'trabalho-externo',
          name: 'Pedido de trabalho externo',
          type: 'Execução',
          description: 'Autorização para trabalho externo',
          icon: 'Briefcase',
          content: `PEDIDO DE TRABALHO EXTERNO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DA EXECUÇÃO

[NOME DO REEDUCANDO] requer autorização para TRABALHO EXTERNO:

I - DOS REQUISITOS
a) Cumprimento de 1/6 da pena
b) Bom comportamento
c) Aptidão laboral
d) Compatibilidade do trabalho

II - DA PROPOSTA DE TRABALHO
Empresa: [NOME]
Função: [CARGO]
Horário: [PERÍODO]
Salário: R$ [VALOR]

III - DOS PEDIDOS
Autorização para trabalho externo

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'saida-temporaria',
          name: 'Pedido de saída temporária',
          type: 'Execução',
          description: 'Saída temporária do estabelecimento penal',
          icon: 'Calendar',
          content: `PEDIDO DE SAÍDA TEMPORÁRIA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DA EXECUÇÃO

[NOME DO REEDUCANDO] requer SAÍDA TEMPORÁRIA:

I - DOS REQUISITOS
a) Comportamento adequado
b) Cumprimento mínimo de 1/6 da pena
c) Compatibilidade do benefício

II - DA FINALIDADE
( ) Visita à família
( ) Frequência a curso
( ) Atividade que concorra para o retorno ao convívio social

III - DAS CONDIÇÕES
[PROPOSTA DE CONDIÇÕES]

IV - DOS PEDIDOS
Concessão da saída temporária

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        }
      ]
    },
    {
      id: 'crimes-especificos',
      name: 'Crimes Específicos',
      emoji: '🎯',
      templates: [
        {
          id: 'defesa-furto',
          name: 'Defesa em crime de furto',
          type: 'Defesa',
          description: 'Defesa específica para furto',
          icon: 'Eye',
          content: `DEFESA - CRIME DE FURTO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa de [NOME DO RÉU] no crime de furto sustenta:

I - DA ATIPICIDADE
[AUSÊNCIA DE ELEMENTOS DO TIPO]

II - DA INEXISTÊNCIA DE DOLO
[DEMONSTRAÇÃO]

III - DO PRINCÍPIO DA INSIGNIFICÂNCIA
a) Mínima ofensividade da conduta
b) Nenhuma periculosidade social da ação
c) Reduzido grau de reprovabilidade do comportamento
d) Inexpressividade da lesão jurídica

IV - DOS PEDIDOS
a) Absolvição
b) Aplicação do princípio da insignificância

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-roubo',
          name: 'Defesa em crime de roubo',
          type: 'Defesa',
          description: 'Defesa específica para roubo',
          icon: 'AlertTriangle',
          content: `DEFESA - CRIME DE ROUBO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa sustenta:

I - DA DESCLASSIFICAÇÃO
Desclassificação para furto por ausência de violência/grave ameaça.

II - DA NEGATIVA DE AUTORIA
[ARGUMENTAÇÃO]

III - DA INEXISTÊNCIA DE DOLO
[DEMONSTRAÇÃO]

IV - DAS ATENUANTES
a) Confissão espontânea
b) Primariedade
c) Bons antecedentes

V - DOS PEDIDOS
a) Absolvição
b) Desclassificação para furto
c) Reconhecimento de atenuantes

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-estelionato',
          name: 'Defesa em crime de estelionato',
          type: 'Defesa',
          description: 'Defesa específica para estelionato',
          icon: 'CreditCard',
          content: `DEFESA - CRIME DE ESTELIONATO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa no crime de estelionato alega:

I - DA AUSÊNCIA DE FRAUDE
[DEMONSTRAÇÃO]

II - DA BOA-FÉ DO ACUSADO
[ARGUMENTAÇÃO]

III - DA INEXISTÊNCIA DE DOLO
[FUNDAMENTAÇÃO]

IV - DA REPARAÇÃO DO DANO
[COMPROVAÇÃO]

V - DOS PEDIDOS
a) Absolvição
b) Reconhecimento da boa-fé
c) Consideração da reparação do dano

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-receptacao',
          name: 'Defesa em crime de receptação',
          type: 'Defesa',
          description: 'Defesa específica para receptação',
          icon: 'Package',
          content: `DEFESA - CRIME DE RECEPTAÇÃO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa na receptação sustenta:

I - DA BOA-FÉ NA AQUISIÇÃO
[DEMONSTRAÇÃO DO DESCONHECIMENTO]

II - DA ORIGEM LÍCITA
[PROVA DA LICITUDE]

III - DA PRESUNÇÃO DE INOCÊNCIA
[INSUFICIÊNCIA PROBATÓRIA]

IV - DOS PEDIDOS
a) Absolvição por insuficiência de provas
b) Reconhecimento da boa-fé

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-apropriacao-indebita',
          name: 'Defesa em apropriação indébita',
          type: 'Defesa',
          description: 'Defesa específica para apropriação indébita',
          icon: 'Wallet',
          content: `DEFESA - APROPRIAÇÃO INDÉBITA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa alega:

I - DA INEXISTÊNCIA DE APROPRIAÇÃO
[DEMONSTRAÇÃO]

II - DA POSSE LEGÍTIMA
[FUNDAMENTAÇÃO]

III - DA AUSÊNCIA DE DOLO
[ARGUMENTAÇÃO]

IV - DA RESTITUIÇÃO
[COMPROVAÇÃO]

V - DOS PEDIDOS
a) Absolvição
b) Reconhecimento da posse legítima

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-violencia-domestica',
          name: 'Defesa em violência doméstica',
          type: 'Defesa',
          description: 'Defesa específica para violência doméstica',
          icon: 'Home',
          content: `DEFESA - VIOLÊNCIA DOMÉSTICA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa sustenta:

I - DA AUSÊNCIA DE VIOLÊNCIA
[NEGATIVA DOS FATOS]

II - DO CONTEXTO FAMILIAR
[ESCLARECIMENTOS]

III - DA RECONCILIAÇÃO
[SE HOUVER]

IV - DAS MEDIDAS SOCIOEDUCATIVAS
[PROPOSTA]

V - DOS PEDIDOS
a) Absolvição
b) Suspensão condicional do processo
c) Aplicação de medidas alternativas

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'defesa-dirigir-embriagado',
          name: 'Defesa em embriaguez ao volante',
          type: 'Defesa',
          description: 'Defesa para crime de trânsito',
          icon: 'Car',
          content: `DEFESA - EMBRIAGUEZ AO VOLANTE

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

A defesa no crime do art. 306 do CTB alega:

I - DA NULIDADE DO TESTE
[VÍCIOS PROCEDIMENTAIS]

II - DA AUSÊNCIA DE EMBRIAGUEZ
[CONTESTAÇÃO DA PROVA]

III - DO ESTADO DE NECESSIDADE
[SE APLICÁVEL]

IV - DA PRIMARIEDADE
[ATENUANTE]

V - DOS PEDIDOS
a) Absolvição
b) Nulidade das provas
c) Suspensão condicional do processo

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        }
      ]
    }
  ]
};
